export const REGIONS_WITH_UNDERGROUND = [1, 4593, 2, 4743, 4777, 4885, 4897, 4966];
